import { useMutation } from "@apollo/client";
import { REMOVE_GIVEN_CANS } from "../given-cans.queries";
import {
  RemoveGivenCansMutation,
  RemoveGivenCansMutationVariables,
} from "../../../__generated__/RemoveGivenCansMutation";

export const useRemoveGivenCans = () => {
  return useMutation<RemoveGivenCansMutation, RemoveGivenCansMutationVariables>(
    REMOVE_GIVEN_CANS,
    {
      refetchQueries: "active",
    }
  );
};
